import Banner from "../components/Banner.js";
import image_top from "../assets/enginuity_home_top.jpg";
import {
  FaRegStar,
  FaCogs,
  FaGraduationCap,
  FaLaptopCode,
} from "react-icons/fa";
import { GiBullseye } from "react-icons/gi";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
export default function Home() {
  return (
    <>
      <Banner />
      <div className="max-w-7xl mx-auto px-10 py-20 space-y-20">
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 justify-center items-center">
          <div>
            <h2 className="text-left border-l-8 0 pl-2 py-2 bg-clip-text text-purple-900 border-purple-900">
              About Enginuity Systems
            </h2>
            <p className="mb-4">
              <strong className="text-purple-800">Enginuity Systems</strong> is
              a modern technology company that blends{" "}
              <strong className="text-purple-800">software development</strong>{" "}
              with{" "}
              <strong className="text-purple-800">
                skills-based education
              </strong>{" "}
              to build both digital products and digital professionals. We
              empower individuals from diverse educational backgrounds —
              especially{" "}
              <strong className="text-purple-800">non-CSE graduates</strong> and{" "}
              <strong className="text-purple-800">diploma holders</strong> — to
              become job-ready backend engineers, while also delivering
              scalable, enterprise-grade{" "}
              <strong className="text-purple-800">
                software and web solutions
              </strong>{" "}
              to clients
            </p>

            <p className="mb-4">
              We specialize in both{" "}
              <strong className="text-purple-800">
                industry-standard training
              </strong>{" "}
              and{" "}
              <strong className="text-purple-800">
                full-cycle software development
              </strong>
              , combining real-world project experience, practical DevOps
              workflows, and backend architecture into one unified platform.
              Whether you're a learner seeking to upskill or a business looking
              to build reliable systems,{" "}
              <strong className="text-purple-800">
                Enginuity Systems bridges education and execution
              </strong>{" "}
              with unmatched precision
            </p>

            <p className="mb-4">
              We don’t just teach tech — we build it. Through real projects,
              version control, APIs, cloud infrastructure, CI/CD pipelines, and
              enterprise-level tools, our students and clients benefit from{" "}
              <strong className="text-purple-800">
                production-ready thinking
              </strong>{" "}
              every step of the way.
            </p>
          </div>
          <div>
            <img className="rounded-lg" src={image_top} alt="" />
          </div>
        </section>

        {/* our mission and Vision section */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10  ">
          <div className="text-white p-10 bg-purple-900 rounded-2xl">
            <GiBullseye className="text-5xl md:text-7xl mb-4" />
            <h2 className="p-0"> Our Mission</h2>
            <h4 className="text-lg font-bold">Our mission is twofold:</h4>
            <ol className="flex flex-col gap-5 mt-4">
              <li>
                1. To{" "}
                <strong className="text-purple-200">
                  build world-class backend systems and applications
                </strong>{" "}
                that solve real business problems with clarity, speed, and
                scalability.
              </li>
              <li>
                2. To{" "}
                <strong className="text-purple-200">
                  create industry-ready backend engineers
                </strong>{" "}
                through practical, project-driven learning that mirrors real
                software team workflows.
              </li>
            </ol>

            <p className="my-4">
              We’re here to{" "}
              <strong className="text-purple-200">close the gap</strong> between
              software education and professional execution — helping both
              learners and businesses move forward with confidence.
            </p>
          </div>

          <div className="text-white p-10 bg-purple-900 rounded-2xl">
            <FaRegStar className="text-5xl md:text-7xl mb-4" />
            <h2 className="p-0">Our Vision</h2>

            <p className="mb-4">
              We envision a future where{" "}
              <strong className="text-purple-200">
                quality code, skilled developers, and functional software
              </strong>{" "}
              are accessible to all — regardless of academic background. Our
              goal is to become the go-to name for backend systems development
              and real-world tech training across India and beyond.
            </p>
            <p className="mb-4">
              Whether you're a business needing a robust backend or a student
              looking for a career path —{" "}
              <strong className="text-purple-200">
                Enginuity Systems is your technical partner.
              </strong>
            </p>
          </div>
        </section>

        {/* what we do heading  */}
        <section>
          <div className="md:w-4/6 mx-auto text-center flex flex-col justify-center items-center">
            <h2 className="text-left pl-2 pt-2 bg-clip-text text-purple-900">
              What We Do
            </h2>
            <div className="w-20 h-2 bg-gradient-to-tr from-purple-600 to-blue-800 rounded-full"></div>
            <p className="mt-3">
              At Enginuity Systems, we operate across two core verticals to
              deliver maximum impact — one focused on building scalable
              software, the other on building skilled engineers.
            </p>
          </div>
        </section>

        {/* custom server and web applications development */}
        <section className="">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-left border-l-8 0 pl-2 py-2 bg-clip-text text-purple-900 border-purple-900">
              Custom Software & Web Application Development
            </h2>
            <p className="text-lg text-gray-600 mb-12">
              We partner with startups, SMEs, and enterprises to build scalable,
              maintainable, and production-grade software tailored to real
              business needs.
            </p>

            <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-2">
              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3 mt-5 md:mt-4 ">
                  API Development & Integration
                </h3>
                <p>
                  We build robust, RESTful APIs that are{" "}
                  <strong>secure, scalable, and well-documented</strong> —
                  enabling seamless communication across your systems and
                  third-party platforms. Whether it's internal microservices or
                  public endpoints, we deliver reliable interfaces that scale
                  with your business.
                </p>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    1
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3 mt-5 md:mt-5 ">
                  Database-Driven Web Applications
                </h3>

                <p>
                  Our apps are designed to be fast, reliable, and optimized for
                  data-heavy operations. We specialize in:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>
                    <strong>Node.js & Express.js</strong> backend stacks
                  </li>
                  <li>
                    <strong>MongoDB & MySQL</strong> for structured and flexible
                    data models
                  </li>
                  <li>
                    Clean REST APIs with role-based access control and
                    middleware support
                  </li>
                </ul>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    2
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Cloud & CI/CD Infrastructure
                </h3>
                <p>
                  Deployment shouldn’t be an afterthought. We use cloud-native
                  tools and DevOps pipelines to ensure every build is{" "}
                  <strong>automated, testable, and deployable:</strong>
                </p>

                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>
                    <strong>Dockerized environments</strong> for consistent
                    builds
                  </li>
                  <li>
                    <strong>AWS & Firebase</strong> for scalable hosting and
                    cloud services
                  </li>
                  <li>
                    <strong>CI/CD pipelines</strong> using GitHub Actions for
                    rapid, safe deployment cycles
                  </li>
                </ul>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    3
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Product Lifecycle Ownership
                </h3>

                <p>
                  We don’t just code — we take full ownership of the product
                  journey. From early-stage discovery to post-deployment
                  support, we ensure every system is:
                </p>

                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>Strategically planned with clients</li>
                  <li>Iteratively developed using best practices</li>
                  <li>Thoroughly tested before launch</li>
                  <li>TEasy to maintain and scale as business grows</li>
                </ul>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    4
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Agile Development & Support
                </h3>
                <p>
                  We follow agile principles to keep projects lean, adaptive,
                  and transparent:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>Sprint-based workflows</li>
                  <li>Project tracking via Jira</li>
                  <li>Continuous integration with Git and GitHub</li>
                  <li>
                    Regular retrospectives and iterations for evolving needs
                  </li>
                </ul>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    5
                  </span>
                </div>
              </div>

              <div className="bg-purple-800 text-white rounded-md p-6 flex flex-col justify-between">
                <h3 className="text-xl font-bold text-white mb-3">
                  Engineering You Can Trust — Powering SaaS, Automation, and
                  Scalable Solutions
                </h3>
                <p className="text-white/90 mb-6 text-lg">
                  Whether you're launching a SaaS product, automating business
                  processes, or scaling your internal tools —{" "}
                  <strong>
                    Enginuity Systems delivers engineering you can trust
                  </strong>
                </p>
                <Link
                  to="/service"
                  className="bg-white py-2 text-purple-700 rounded-md font-bold text-center"
                >
                  Services
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Industrial Training for Non-CSE & Diploma Students */}
        <section className="">
          <div className="max-w-7xl mx-auto">
            <div>
              <h2 className="text-left border-l-8 0 pl-2 py-2 bg-clip-text text-purple-900 border-purple-900">
                Industrial Training for Non-CSE & Diploma Students
              </h2>
              <p className="text-lg text-gray-600 mb-12">
                At <strong>Enginuity Systems</strong>, we believe that talent
                and passion matter more than degrees. That’s why we’ve created a{" "}
                <strong>career-launching backend engineering program</strong>{" "}
                specifically for{" "}
                <strong>
                  diploma holders, non-CSE graduates, and self-taught learners
                </strong>{" "}
                looking to break into the tech industry
              </p>
              <p className="text-lg text-gray-600 mb-12">
                This isn’t classroom theory — it’s hands-on, job-focused
                training that mimics how real software teams work. Our
                curriculum is designed to help students{" "}
                <strong>
                  build, deploy, and maintain real-world software systems,
                </strong>{" "}
                using the same tools and workflows used in the industry.
              </p>
            </div>
          
            <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-2">
              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3 mt-5 md:mt-4 ">
                  Zero-to-Backend Developer Program
                </h3>
                <p>
                  A complete roadmap for students starting from scratch — no CS
                  degree required. We cover the{" "}
                  <strong>fundamentals of software engineering,</strong> backend
                  architecture, version control, and cloud deployment — with
                  plenty of hands-on practice at every stage
                </p>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    1
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3 mt-5 md:mt-5 ">
                  Real SDLC Workflows (Software Development Life Cycle)
                </h3>

                <p>
                  We train students to think and work like real developers. From
                  requirement analysis and task breakdown to versioning,
                  development, testing, and final deployment — learners go
                  through the <strong>entire SDLC process</strong> multiple
                  times on real projects.
                </p>
                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    2
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Capstone & Market Projects
                </h3>
                <p>
                  Every student builds at least one{" "}
                  <strong>capstone project</strong> that represents their
                  skillset. In many cases, these are
                  <strong>market-ready apps</strong> — such as inventory
                  systems, CMS platforms, or customer portals — that may be
                  pitched or sold to real clients. This gives learners exposure
                  to business, product thinking, and client interaction.
                </p>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    3
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Full Documentation Pack
                </h3>

                <p>
                  Learning to code is only half the job — writing and
                  understanding documentation is just as critical.
                  <br />
                  We teach students to:
                </p>

                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>
                    Write clear <strong>requirement documents</strong>
                  </li>
                  <li>
                    Create and use <strong>API specifications</strong>
                  </li>
                  <li>
                    Maintain <strong>README files,</strong> deployment guides,
                    and testing documents
                  </li>
                  <li>
                    Contribute to{" "}
                    <strong>team-based version-controlled codebases</strong>
                  </li>
                </ul>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    4
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Mentorship from Working Engineers
                </h3>
                <p>
                  Students aren’t left on their own — we assign{" "}
                  <strong>active industry professionals</strong> as mentors.
                  Through <strong>weekly live sessions</strong>, code reviews,
                  project feedback, and career Q&As, students get insider
                  knowledge on:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>Backend engineering practices</li>
                  <li>Interview preparation</li>
                  <li>Code structuring and debugging</li>
                  <li>Real career paths and progression in tech</li>
                </ul>

                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 md:w-32 h-32 md:h-32 rounded-full">
                  <span className="text-3xl md:text-4xl font-bold text-white absolute bottom-6 md:bottom-6 left-8 md:left-8">
                    5
                  </span>
                </div>
              </div>

            <div className="bg-white rounded-md p-6 border border-purple-200 text-gray-600 relative overflow-hidden">
                <h3 className="text-xl font-bold text-purple-600 mb-3">
                  Bonus: Career-Readiness Training
                </h3>
                <p>
                  <strong>Our program also includes:</strong>
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-1 mt-3">
                  <li>Resume and portfolio building</li>
                  <li>GitHub profile optimization</li>
                  <li>Mock interviews with real developers</li>
                  <li>Job search strategy sessions</li>
                </ul>

                {/* Decorative Purple Circle */}
                <div className="absolute -right-14 -top-14 bg-purple-800 w-32 h-32 rounded-full">
                  <span className="text-3xl font-bold text-white absolute bottom-6 left-8">
                    6
                  </span>
                </div>

                {/* Push button to bottom */}
                <div className="mt-auto flex justify-end pt-10">
                  <Link
                    to="/training"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-md shadow-lg font-semibold hover:bg-purple-700 transition duration-300 ease-in-out animate-pulse"
                  >
                    Register Now
                    <BsArrowRight className="w-5 h-5" />
                  </Link>
                </div>
              </div>

            </div>

            <div className="bg-purple-800 text-white text-center px-10 py-5 mt-5 rounded-md">
              <p>
                Whether you're starting from zero or switching careers,{" "}
                <strong>
                  Enginuity Systems equips you with the skills, projects, and
                  confidence to succeed as a backend engineer
                </strong>{" "}
                in today’s tech industry.
              </p>
            </div>

          </div>



        </section>

        {/* what we offer  */}
        <section className="">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-left border-l-8 0 pl-2 py-2 bg-clip-text text-purple-900 border-purple-900">
              What We Offer
            </h2>
            <div className="grid md:grid-cols-3  gap-8">
              {/* Software Solutions */}
              <div className="flex flex-col items-center text-center py-10 px-6 bg-white rounded-2xl border border-purple-900 shadow-lg shadow-purple-500/30 transition-shadow duration-300 group">
                <div className="bg-gradient-to-br from-purple-600 to-blue-700 p-4 rounded-full shadow-md mb-4 group-hover:scale-105 transition-transform">
                  <FaLaptopCode className="text-4xl text-white" />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  Software Solutions
                </h3>

                {/* Divider */}
                <div className="w-24 h-1.5 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full mb-5"></div>

                {/* Features List */}
                <ul className="list-none text-gray-600 space-y-2 text-sm sm:text-base">
                  <li>Custom backend APIs and platforms</li>
                  <li>Full-stack MVPs</li>
                  <li>Legacy system modernization</li>
                  <li>Tech consulting for small businesses</li>
                </ul>
              </div>


              {/* Tech Stack Expertise */}
              <div className="flex flex-col items-center text-center py-10 px-6 bg-white rounded-2xl border border-purple-900 shadow-lg shadow-purple-500/30 transition-shadow duration-300 group">
                <div className="bg-gradient-to-br from-purple-600 to-indigo-700 p-4 rounded-full shadow-md mb-4 group-hover:scale-105 transition-transform">
                  <FaCogs className="text-4xl text-white" />
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  Tech Stack Expertise
                </h3>

                <div className="w-24 h-1.5 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-full mb-5"></div>

                <ul className="text-gray-600 space-y-2 text-sm sm:text-base list-none">
                  <li>JavaScript, TypeScript, Python, C#, Java, Node.js, Express.js, NestJS, Flask, FastAPI, Spring Boot, .NET Core</li>
                  <li>MySQL, PostgreSQL, MSSQL, MongoDB, Oracle DB, Redis, Elasticsearch</li>
                  <li>Docker, Kubernetes, GitHub Actions, Jenkins, Terraform, Helm</li>
                  <li>AWS, Firebase, DigitalOcean</li>
                  <li>Redis, RabbitMQ, Kafka, Amazon SQS</li>
                </ul>
              </div>


              {/* Training Programs */}
              <div className="flex flex-col items-center text-center py-10 px-6 bg-white rounded-2xl border border-purple-900 shadow-lg shadow-purple-500/30 transition-shadow duration-300 group">
                <div className="bg-gradient-to-br from-purple-600 to-blue-700 p-4 rounded-full shadow-md mb-4 group-hover:scale-105 transition-transform">
                  <FaGraduationCap className="text-4xl text-white" />
                </div>

                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                  Training Programs
                </h3>

                <div className="w-24 h-1.5 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full mb-5"></div>

                <ul className="list-none text-gray-600 space-y-2 text-sm sm:text-base">
                  <li>Backend Development Bootcamp</li>
                  <li>Full SDLC Project Mentorship</li>
                  <li>DevOps & Cloud Basics for Beginners</li>
                  <li>Career readiness modules</li>
                </ul>
              </div>

            </div>
          </div>
        </section>

        {/* Why Choose Enginuity Systems? */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 justify-center items-center">
          <div>
            <img className="rounded-lg" src={image_top} alt="" />
          </div>

          <div>
            <h2 className="text-left border-l-8 0 pl-2 py-2 bg-clip-text text-purple-900 border-purple-900">
              Why Choose Enginuity Systems?
            </h2>
            <p className="mb-4">
              Whether you're a client or a learner, here’s what sets us apart:
            </p>

            <ul className="space-y-3 text-gray-700 text-base leading-relaxed list-none">
              <li className="flex items-start gap-2">
                <span className="text-green-600 text-xl mt-1">✔️</span>
                <span>
                  <strong>No CS Degree Required</strong> — Skill-based entry
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 text-xl mt-1">✔️</span>
                <span>
                  <strong>Production-Ready Software</strong> — Build and deliver
                  real systems
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 text-xl mt-1">✔️</span>
                <span>
                  <strong>End-to-End Learning & Development</strong> — From
                  requirements to deployment
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 text-xl mt-1">✔️</span>
                <span>
                  <strong>Cloud-Native Thinking</strong> — Apps that scale
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 text-xl mt-1">✔️</span>
                <span>
                  <strong>Mentorship from Industry Pros</strong> — Weekly
                  check-ins, feedback, and support
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-600 text-xl mt-1">✔️</span>
                <span>
                  <strong>Real Projects, Real Results</strong> — What you build
                  here, works in the real world
                </span>
              </li>
            </ul>
          </div>
        </section>

        {/* final thoughts  */}
        <section className="bg-gradient-to-br from-purple-50 to-white py-5 px-6 md:px-12 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl font-bold text-purple-800 flex items-center justify-center gap-3 mb-6">
              <span className="text-5xl">🧭</span>
              Final Thoughts
            </h2>

            <p className="text-gray-700 text-lg mb-6">
              Whether you’re a student trying to break into backend engineering
              or a company looking for custom software,{" "}
              <span className="font-semibold text-purple-800">
                Enginuity Systems
              </span>{" "}
              is your all-in-one tech partner.
            </p>

            <div className="text-xl text-gray-800 font-semibold space-y-2">
              <p>We don't just build apps.</p>
              <p>We don’t just teach backend.</p>
              <p>
                We build <span className="text-purple-700">engineers</span>.
              </p>
              <p>
                We build <span className="text-purple-700">solutions</span>.
              </p>
              <p>
                We build the <span className="text-purple-700">future</span> —
                one deployment at a time.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
